import { LinkedinIcon } from '../assets/svgs/LinkedinIcon';

// import facebook from './../assets/svgs/facebook.svg';
// import instagram from './../assets/svgs/instagram.svg';
// import linkedIn from './../assets/svgs/linkedin.svg';
// import tiktok from './../assets/svgs/tiktok.svg';
// import twitter from './../assets/svgs/twitter.svg';

const SOCIAL_MEDIA = [
	{
		key: 'linkedIn',
		label: 'Sawaed on LinkedIn',
		link: 'https://www.linkedin.com/company/sawaed-group',
		Icon: LinkedinIcon,
	},
	// {
	// 	key: 'facebook',
	// 	imageSrc: facebook,
	// 	link: '',
	// },
	// {
	// 	key: 'instagram',
	// 	imageSrc: instagram,
	// 	link: '',
	// },
	// {
	// 	key: 'tiktok',
	// 	imageSrc: tiktok,
	// 	link: '',
	// },
	// {
	// 	key: 'twitter',
	// 	imageSrc: twitter,
	// 	link: '',
	// },
];

export const SocialMedia = (props) => {
	return (
		<ul className='flex gap-6'>
			{SOCIAL_MEDIA.map((item) => {
				const { key, label, Icon, link } = item;
				return (
					<li key={key}>
						<a
							href={link}
							target='_blank'
							rel='noreferrer'
							aria-label={label}>
							<Icon color={props.color} />

							{/* <img
								width={24}
								height={24}
								src={imageSrc}
								alt={key + '-social-media'}
							/> */}
						</a>
					</li>
				);
			})}
		</ul>
	);
};
